module.exports = __webpack_public_path__ + "img/ordToning3.19112310.jpg";